// src/data/goalSkillMapping.js
// 目標キーワードと、それに関連するNOBISHIRO能力のマッピング

export const goalSkillMapping = {
  // キーワード (正規表現で使用できるよう小文字で定義)
  'リーダー|マネジメント|管理|率いる': {
    description: 'チームを率い、目標達成に導く役割',
    requiredAbilities: ['H', 'S', 'B', 'I2', 'O'], // 協働力, 共感力, バランス力, 主体性, 思考力
  },
  'データ分析|データ活用|分析': {
    description: 'データを基に洞察を得て、意思決定に活かす役割',
    requiredAbilities: ['O', 'O2', 'R', 'N', 'B'], // 思考力, 最適化力, 振り返り力, 粘り強さ, バランス力
  },
  '新規事業|企画|アイデア|創造': {
    description: '新しい価値を生み出すための企画・立案',
    requiredAbilities: ['I', 'I2', 'O', 'H', 'R'], // イノベーション力, 主体性, 思考力, 協働力, 振り返り力
  },
  'プレゼン|伝える|発表': {
    description: '他者に分かりやすく情報を伝え、行動を促す能力',
    requiredAbilities: ['S', 'O', 'B', 'I2', 'H'], // 共感力, 思考力, バランス力, 主体性, 協働力
  },
  '技術|スキル|専門性|習得': {
    description: '特定の専門分野における深い知識と技術の習得',
    requiredAbilities: ['N', 'R', 'O2', 'O', 'I'], // 粘り強さ, 振り返り力, 最適化力, 思考力, イノベーション力
  },
};
